import React from 'react'

class Storage extends React.Component {
  static set (key, value) {
    return window.localStorage.setItem(key, value)
  }

  static get (key) {
    return window.localStorage.getItem(key)
  }

  static remove (key) {
    return window.localStorage.removeItem(key)
  }

  render () {
    const { children } = this.props

    return children({
      set: Storage.set,
      get: Storage.get,
      remove: Storage.remove
    })
  }
}

export default Storage
